module.exports = __webpack_public_path__ + "img/horizontal_4_3_3009.8f823e5c.png";